import { render } from "./OutsideIframe.vue?vue&type=template&id=edbf92e6&scoped=true&ts=true"
import script from "./OutsideIframe.vue?vue&type=script&lang=ts"
export * from "./OutsideIframe.vue?vue&type=script&lang=ts"

import "./OutsideIframe.vue?vue&type=style&index=0&id=edbf92e6&scoped=true&lang=scss"

import exportComponent from "/data/.jenkins/workspace/k8s-shouba-exhibitionhall-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edbf92e6"]])

export default __exports__